import { useCallback } from 'react';

import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';

type UseErrorScreenReturn = ModelHookResult<undefined, { handlePrimaryActionClick: () => void }>;

export function useErrorScreen(): UseErrorScreenReturn {
	const { actions } = useStartAPetitionPageState();

	const startFromScratch = useCallback(() => {
		actions.send({ type: 'error' });
	}, [actions]);

	const handlePrimaryActionClick = useCallback(() => {
		startFromScratch();
	}, [startFromScratch]);

	return {
		actions: {
			handlePrimaryActionClick,
		},
	};
}
